import { useTranslation } from "@impero-com/common/utils/i18n";
import { emitNotification } from "@impero-com/ui";
import { useQueryClient } from "@tanstack/react-query";

import {
    getGetEntitiesEntityIdQueryKey,
    getGetEntitiesQueryKey,
    usePatchEntitiesEntityId,
} from "api/generated/entities/entities";

export function useUpdateEntityMutation() {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return usePatchEntitiesEntityId({
        mutation: {
            onSuccess: (_response, { entityId }) => {
                queryClient.invalidateQueries({
                    queryKey: getGetEntitiesEntityIdQueryKey(entityId),
                });
                queryClient.invalidateQueries({
                    queryKey: getGetEntitiesQueryKey(),
                });
            },
            onError: (error) => {
                console.error("Update failed:", error);
                emitNotification("error", t("Entities_SubmitValidationError"));
            },
        },
    });
}
